import getOr from 'lodash/fp/getOr';
import flow from 'lodash/fp/flow';
import { formatCreditCard } from '../../common/CreditCard';

export const price = state => state.payment.price;
export const kind = state => state.payment.kind;
export const type = state => state.payment.type;

export const getCard = getOr({}, 'payment.paymentCard');
export const getCardId = getOr('', 'payment.paymentCard.id');

export const getPaymentCardBrand = getOr('', 'payment.paymentCard.details.brand');
export const getPaymentCardUpdatedAt = getOr('', 'payment.paymentCard.updatedAt');
export const getPaymentCardChangeRequired = getOr(false, 'payment.paymentCard.paymentCustomerChangeRequired');
export const getPaymentCardIsSquirePay = getOr(false, 'payment.paymentCard.isSquirePay');

export const getPaymentCardLast4 = getOr('', 'payment.paymentCard.details.last4');
export const getCardNumber = flow([
  getPaymentCardLast4,
  formatCreditCard,
]);

export const getCardDetails = getOr('', 'payment.paymentCard.details');

export const getPayingObject = getOr({}, 'payment.payingObject');
export const getPayingObjectGiftCard = getOr({}, 'payment.payingObject.giftCard');
